export default __webpack_public_path__ + "static/test_2_1-31dab7714b4704c11e601b2bf1032d2a.png";